<template>
	<v-flex xs12>
		<EditSlide v-if="editDialog"></EditSlide>
		
		<v-form ref="form">
			<v-textarea
				:label="translater.__('Content', 'tasks')"
				v-model="slide"
			>
				
			</v-textarea>
		</v-form>
		<v-btn
	    	fab
	    	right
	    	absolute
	    	small
	    	color="success"
	    	@click="addSlide()"
	    	:disabled="!validSlide"
	    	
	    >
	    	<v-icon>add</v-icon>

	    </v-btn>
		<v-layout row>
			<v-flex sm12 lg12>
				<v-list two-line v-if="typeof answers !== 'undefined'">
					<!--template v-for="key in Object.keys(answers)"-->
						<v-list-tile v-for="(key, i) in Object.keys(answers)" :key="i">
							<v-list-tile-content v-if="answers[key].delete !== true">
								<v-list-tile-title></v-list-tile-title>
								{{answers[key].content}}
							</v-list-tile-content>
							<v-list-tile-content v-else>
								{{translater.__('Are you sure you want to delete the slide', 'tasks')}}
							</v-list-tile-content>
							<v-list-tile-action v-if="answers[key].delete !== true">
								<v-btn @click="editSlide(key)" icon>
									<v-icon>edit</v-icon>
								</v-btn>
								<v-btn @click="confirmSlideDelete(key)" icon>
									<v-icon>delete</v-icon>
								</v-btn>
							</v-list-tile-action>
							<v-list-tile-action v-else>
								<v-btn @click="deleteSlide(key)" icon>
									<v-icon>check</v-icon>
								</v-btn>
								<v-btn @click="cancelDeleteSlide(key)" icon>
									<v-icon>cancel</v-icon>
								</v-btn>
							</v-list-tile-action>
						</v-list-tile>
					<!--/template-->
				</v-list>	
			</v-flex>
		</v-layout>
		<v-card-actions>
			        	<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="update"></SuccessButton>
			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => edit = false"></ErrorButton>
			        </v-card-actions>
	</v-flex>
</template>

<script>

	import EditSlide from './EditSlide';
	import SuccessButton from '../../../common/components/SuccessButton';
	import ErrorButton from '../../../common/components/ErrorButton'

	export default {
		name: 'EditSlidesTask',
		components: {
			ErrorButton,
			SuccessButton,
			EditSlide
		},
		mounted()
		{
			
		},

		methods: {

			update()
			{
				this.$store.dispatch('checkpoints/updateTask')
			},

			editSlide(key)
			{
				
				this.$store.dispatch('checkpoints/editSlide', {key: key, edit: true})
				//this.editDialog = true;
			}, 

			deleteSlide(key)
			{
				this.$store.dispatch('checkpoints/deleteSlide', {key:key, edit: true})
			},

			confirmSlideDelete(key)
			{
				this.$store.dispatch('checkpoints/confirmSlideDelete', {key:key, edit: true})
			},

			cancelDeleteSlide(key)
			{
				this.$store.dispatch('checkpoints/cancelDeleteSlide', {key:key, edit: true})
			},

			addSlide()
			{
				
				if(this.slide.trim() === '')
				{
					return;
				}
				this.answers = this.slide
			},
		},

		computed: {

			edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},

			validSlide: {
				get()
				{
					return this.slide.trim() !== '';
				},
			},

			valid: {
				get()
				{
					return typeof this.answers !== 'undefined' && Object.keys(this.answers).length > 0
				}
			},

			translater: 
			{
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			slide:{
				get()
				{
					return this.$store.getters['checkpoints/slide']
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setSlide', value)
				}
				
			},

			

			answers: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'].question.answers;

				},

				set(value)
				{
					this.$store.dispatch('checkpoints/addSlide', {content:value, edit:true})
					this.slide = '';
				}

				
			},

			editDialog:{
				get()
				{
					return this.$store.getters['checkpoints/isEditingSlide'];
				},

				set(value)
				{
					//console.log("editDialog::set", value)
					this.$store.dispatch('checkpoints/setIsEditingSlide', value)
				}
			},
		}
	}
</script>